import React from 'react';

import type { PanAnimationConfig } from './types';

export const panConfigDefault: PanAnimationConfig = {
  title: 'MAI PUȚINĂ FRECARE, MAI MULT TIMP LIBER',
  subtitle: 'SPALĂ TIGAIA ȘI DESCOPERĂ REDUCEREA',
  completedTitle: 'FELICITĂRI!',
  completedSubtitle: 'Copiază și utilizează reducerea ta',

  skipButtonText: 'Sari peste spălare și dezvăluie reducerea',

  addInfoText: (
    <>
      <p>
        <strong>CÂT ESTE VALABIL CODUL?</strong> Voucherul este activ până la 31.12.2026.
      </p>
      <p>
        <strong>Notă importantă:</strong> Codul promoțional poate fi folosit exclusiv în aplicația
        eMAG pentru achiziția produselor Finish Ultimate Plus vândute de eMAG, în limita stocului
        disponibil. Codul nu se aplică produselor Finish care nu fac parte din gama Ultimate Plus și
        nu este valabil pentru produsele comercializate de partenerii din Marketplace eMag. Poți
        utiliza codul o singură dată pentru cel mult 2 produse eligibile din campanie. Codul promo
        nu se cumulează cu alte campanii promoționale sau coduri de discount active pe platformă
      </p>
      <p>Pentru a beneficia de codul promoțional, trebuie să parcurgeți următorii pași:</p>
      <ul>
        <li>
          să achiziționați o mașină de spălat vase care conține materialul promoțional FINISH cu cod
          QR;
        </li>
        <li>să identificați și să scanați codul QR utilizând un dispozitiv mobil;</li>
        <li>să fiți redirecționati către website-ul Campaniei;</li>
        <li>să vizualizați codul promoțional FINISH afișat pe website;</li>
        <li>
          să utilizați codul promoțional pe platforma eMAG pentru achiziționarea produselor
          eligible.
        </li>
      </ul>
    </>
  ),

  revealedTitle: (
    <>
      <span>30% REDUCERE</span> <br /> LA FINISH ULTIMATE PLUS PE EMAG.RO
    </>
  ),
  revealedSubtitle: 'Felicitări! Copiază și utilizează reducerea ta',

  copyButton: 'Copiază',
  copiedButton: 'Copiat',
  discountSubText: 'CODUL TĂU DE REDUCERE',
  retailerButton: 'Intră pe eMag.ro și cumpără acum',
  retailerUrl: 'https://www.emag.ro/label/Finish-Ultimate-Plus',

  promoId: '4243cae2-acef-4d7e-9b73-46e868933966',
};

export const panConfigBG: PanAnimationConfig = {
  title: 'ПО-МАЛКО ТЪРКАНЕ, ПОВЕЧЕ СВОБОДНО ВРЕМЕ',
  subtitle: 'ИЗМИЙ ТИГАНА И РАЗКРИЙ СВОЯТА ОТСТЪПКА',
  completedTitle: 'Поздравления!',
  completedSubtitle: 'Копирай и използвай своята отстъпка',

  skipButtonText: 'Пропусни миенето и разкрий своята отстъпка',

  addInfoText: (
    <>
      <p>
        КЪДЕ ИЗПОЛЗВАШ КОДА? Кодът е валиден единствено в платформата eMAG.bg за покупка на минимум
        2 продукта, като поне един от тях трябва да бъде Finish Ultimate Plus.
      </p>
      <p>
        <strong>ДО КОГА Е ВАЛИДЕН КОДЪТ?</strong> Ваучерът е активен до 31.12.2026.
      </p>
      <p>
        <strong>Важна забележка:</strong> Промоционалният код може да се използва само в
        приложението eMAG, до изчерпване на наличностите. Кодът не се прилага за продукти на Finish,
        които не са част от серията Ultimate Plus, и не е валиден за продукти, продавани от
        партньори в Marketplace на eMAG. Промо кодът не може да се комбинира с други промоционални
        кампании или активни кодове за отстъпка в платформата.
      </p>
      <p>За да се възползвате от промоционалния код, трябва да изпълните следните стъпки:</p>
      <ul>
        <li>
          да закупите съдомиялна машина, която съдържа промоционалния материал FINISH с QR код;
        </li>
        <li>да откриете и сканирате QR кода с помощта на мобилно устройство;</li>
        <li>да бъдете пренасочени към уебсайта на Кампанията;</li>
        <li>да видите промоционалния код FINISH, показан на уебсайта;</li>
        <li>
          да използвате промоционалния код в платформата eMAG за закупуване на допустимите продукти.
        </li>
      </ul>
    </>
  ),

  revealedTitle: (
    <>
      <span>Спести 10%</span> <br /> ЗА FINISH ULTIMATE PLUS В EMAG.BG
    </>
  ),
  revealedSubtitle: 'Поздравления! Копирай и използвай своята отстъпка',

  copyButton: 'Копирай',
  copiedButton: 'Копирано',
  discountSubText: 'ТВОЯТ КОД ЗА ОТСТЪПКА',
  retailerButton: 'Влез в eMag.bg и купи сега',
  retailerUrl: 'https://www.emag.bg/label/Finish-Ultimate-Plus',

  promoId: '4243cae2-acef-4d7e-9b73-46e868933966',
};
